module.exports = __webpack_public_path__ + "img/首页培训内容.17f1488f.png";